let outOfStockCache = {};

/**
 * Reset out of stock cache.
 */
export function outOfStockResetCache() {
    outOfStockCache = {};
}

// eslint-disable-next-line import/prefer-default-export
export function isOutOfStockCached(atsLocations, controller, component) {
    // The logic is basically like:
    // return this.viewController.isAllowed(pet) && !this.viewController.isAvailable(pet);
    //
    // However, since we check this very often, out of stock check takes a significant amount of time.
    // We could be smarter about checking those, but for now...
    // The blunt approach.
    //
    // If the component was allowed... cache the check result.
    // It's not like a component will suddenly disappear _while_ we are in the configurator.
    //
    // (25-04-26) ^^^^^^^^^^^^^^^^^^^^^^ THIS IS NO LONGER TRUE
    // Component MAY disappear when per-location inventory is in play.
    //
    // If it does, it will be caught in checkout.

    // Calculate locations hash.
    let locations = null;

    const placement = controller.findComponentPlacement(component.code);
    const thisPlacement = `${controller.id}-${placement.code}`;

    if (placement) {
        // eslint-disable-next-line no-restricted-syntax
        for (const p of Object.keys(atsLocations)) {
            if (p !== thisPlacement) {
                if (locations == null) {
                    locations = atsLocations[p];
                } else {
                    locations = locations.intersection(atsLocations[p]);
                }
            }
        }
    }

    const locationsSorted = locations == null ? ['all'] : [...locations];
    locationsSorted.sort();
    const locationsHash = locationsSorted.join('-');

    if (outOfStockCache[locationsHash] == null) {
        outOfStockCache[locationsHash] = {};
    }

    if (outOfStockCache[locationsHash][component.code] != null) {
        return outOfStockCache[locationsHash][component.code];
    }

    const allowed = controller.isAllowed(component);

    if (!allowed) {
        return false;
    }

    const isAvailable = controller.isAvailable(component);

    outOfStockCache[locationsHash][component.code] = !isAvailable;

    return !isAvailable;
}
